
import { Trek } from '@/lib/types/trek-types';

interface TrekOverviewProps {
  trek: Trek;
}

const TrekOverview = ({ trek }: TrekOverviewProps) => {
  return (
    <div id="overview" className="mt-4">
      <h2 className="text-2xl font-bold mb-6">Trek Overview</h2>
      
      <div className="prose prose-lg max-w-none dark:prose-invert">
        {trek.description.includes('<') ? (
          <div dangerouslySetInnerHTML={{ __html: trek.description }} />
        ) : (
          <p className="leading-relaxed text-base whitespace-pre-line">{trek.description}</p>
        )}
      </div>
    </div>
  );
};

export default TrekOverview;
